import { render, staticRenderFns } from "./ViewpointMappingFactor.vue?vue&type=template&id=6654679c&scoped=true&"
import script from "./ViewpointMappingFactor.vue?vue&type=script&lang=ts&"
export * from "./ViewpointMappingFactor.vue?vue&type=script&lang=ts&"
import style0 from "./ViewpointMappingFactor.vue?vue&type=style&index=0&id=6654679c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654679c",
  null
  
)

export default component.exports